import { Outlet } from 'react-router-dom';

import { SurveyLayout } from '@/features/survey';

export const SurveyRootLayout = () => {
  return (
    <SurveyLayout>
      <Outlet />
    </SurveyLayout>
  );
};
